import React, { useState, useEffect } from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";
import axios from "axios";
import { Link } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/blogs`);
        if (response.data.success) {
          setBlogs(response.data.blogs);
        } else {
          setError("Failed to fetch blogs.");
        }
      } catch (err) {
        setError(err.response?.data?.message || "Error fetching blogs.");
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <Head />
      {/* Start Breadcrumbs */}
      <section className="ak-about-hero-1">
        <img
          src="assets/img/bg/blog.png"
          className="about-hero-bg ak-bg object-cover"
          alt="..."
          data-swiper-parallax={1152}
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ color: "white !important" }}
              >
                Blogs
              </p>
              <h2
                className="ak-section-title animation-title"
                style={{ color: "white" }}
              >
                Our Blogs
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white" }}>
              Home / Discover / Our Blogs
            </a>
          </div>
        </div>
      </section>
      {/* End Breadcrumbs */}
      {/* Start Blog Details */}
      <section className="container">
        <div className="ak-height-60 ak-height-lg-50" />
        <div
          className="row justify-content-between flex-lg-row flex-column-reverse"
          id="containerAround"
        >
          <div className="col-lg-12">
            <div className="blog-content-page" id="scrollGaleria">
              {blogs.map((blog) => (
                <Link
                  to={`/blogs/${blog.id}`}
                  key={blog.id}
                  className="blog-card style-2"
                >
                  <div className="blog-img">
                    <img
                      src={`${apiUrl}/${blog.featured_image}`}
                      alt={blog.title}
                    />
                  </div>
                  <div className="blog-card-info">
                    <div className="blog-meta-info">
                      <div className="blog-meta">
                        <span className="blog-author">
                          Admin / {new Date(blog.created_at).toLocaleDateString()}
                        </span>
                      </div>
                      <h5 className="blog-title">{blog.title}</h5>
                    </div>
                    <div className="more-btn">
                      <span>Read More</span>
                      <span className="svg-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={18}
                          height={19}
                          viewBox="0 0 18 19"
                          fill="none"
                        >
                          <path
                            d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                            fill="#030917"
                          />
                          <path
                            d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                            stroke="#030917"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={18}
                          height={19}
                          viewBox="0 0 18 19"
                          fill="none"
                        >
                          <path
                            d="M1.7085 9.01147H16.2918H1.7085ZM16.2918 9.01147L9.29183 2.01147L16.2918 9.01147ZM16.2918 9.01147L9.29183 16.0115L16.2918 9.01147Z"
                            fill="#030917"
                          />
                          <path
                            d="M1.7085 9.01147H16.2918M16.2918 9.01147L9.29183 2.01147M16.2918 9.01147L9.29183 16.0115"
                            stroke="#030917"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className="bottom-border" />
                </Link>
              ))}
              <div className="ak-height-60 ak-height-lg-50" />
              <a href="#" className="ak-center">
                <div className="view-more-button">
                  <div className="more-button">
                    <span>View More</span>
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        height={16}
                        fill="currentColor"
                        className="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.293 7.5H1.5a.5.5 0 0 0 0 1h7.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* End Blog Details */}
      <Foot />
    </>
  );
}

export default Blogs;